<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <!-- Student Header -->
    <student-header [pageTitle]="'Send Email'"
                    *ngIf="!modal"
                    [useYear]="loginYear"
                    [showYearSelector]="true"
                    [disableYearSelect]="true"
                    class="flex-header"></student-header>

    <div mat-dialog-title *ngIf="modal">
        <span>{{banner}}</span>
    </div>

    <!-- Content -->
    <div class="flex-content">

        <!-- Email Header -->
        <div class="headerContainer" *ngIf="!optionNotAvailable">

            <!-- From -->
            <div>
                <label translate>
                    From
                </label>
                <span>
                    <ng-container *ngIf="V10 && generalPreferences && generalPreferences.EmailFrom.toLowerCase() == 'no reply'">
                        {{noReplyEmail}}
                    </ng-container>
                    <ng-container *ngIf="!V10 || !generalPreferences || generalPreferences.EmailFrom.toLowerCase() == 'personal'">

                        <!-- For some reason, we do last name, first name for staff -->
                        <ng-container *ngIf="currentUser.UserType == 1">
                            {{currentUser.LastName}},&nbsp;{{currentUser.FirstName}}&nbsp;&#60;{{currentUser.Email}}&#62;
                        </ng-container>
                        <ng-container *ngIf="currentUser.UserType != 1">
                            {{currentUser.LastName}}&nbsp;{{currentUser.FirstName ? currentUser.FirstName.substring(0, 1) : ''}}
                        </ng-container>
                    </ng-container>
                </span>
            </div>

            <!-- To -->
            <div *ngIf="!modal">
                <button mat-button (click)="changeRecipients()">
                    <label translate>
                        To
                    </label>
                </button>
                <span *ngIf="!mailDetail.toSelectedMailId && toSelected != undefined">
                    {{teacherName}}&nbsp;{{teacherEmailAddress ? '&#60;' + teacherEmailAddress + '&#62;' : ''}}
                </span>
                <span *ngIf="!mailDetail.toSelectedMailId && emailAddress">
                    {{selectedEmailName}}&nbsp;{{emailAddress ? '&#60;' + emailAddress + '&#62;' : ''}}
                </span>
                <span *ngIf="mailDetail.toSelectedMailId">
                    {{mailDetail.toSelectedMailId}}
                </span>
            </div>
            <div *ngIf="modal">
                <label translate>
                    To
                </label>
                <span>
                    {{teacherName}}&nbsp;{{teacherEmailAddress ? '&#60;' + teacherEmailAddress + '&#62;' : ''}}
                </span>
                <span *ngIf="!mailDetail.toSelectedMailId && emailAddress">
                    {{selectedEmailName}}&nbsp;{{emailAddress ? '&#60;' + emailAddress + '&#62;' : ''}}
                </span>
                <span *ngIf="mailDetail.toSelectedMailId">
                    {{mailDetail.toSelectedMailId}}
                </span>
            </div>

            <!-- CC -->
            <div *ngIf="!modal">
                <label>
                    CC
                </label>
                {{mailDetail.CCDisplayMailId}}
            </div>

            <!-- CC -->
            <div *ngIf="modal" style="height: 80px;">
                <label>
                    CC
                </label>
                <tyl-form-field style="width:450px;" hint="Separate addresses with a semicolon">
                    <textarea matInput
                              id='ccField'
                              name='cc'
                              type='text'
                              autocomplete="off"
                              aria-label="CC"
                              [(ngModel)]="mailDetail.CCMailId"
                              rows="1"
                              style="resize: none;">
                </textarea>
                </tyl-form-field>
            </div>

            <!-- BCC -->
            <div *ngIf="!modal">
                <label>
                    BCC
                </label>
                {{mailDetail.BCCDisplayMailId}}
            </div>

            <!-- Subject -->
            <div>
                <label translate>
                    Subject
                </label>
                <tyl-form-field style="width:450px;">
                    <input matInput
                           #subjectField
                           [(ngModel)]="mailDetail.subject"
                           (input)="emailChanged = true"
                           autocomplete="off"
                           aria-label="Subject"
                           name="subject"
                           id="subjectField" />
                </tyl-form-field>
            </div>

            <!-- Attachments -->
            <div *ngIf="!modal">
                <button mat-button
                        (click)="addAttachment()">
                    <label translate>
                        Attachments
                    </label>
                </button>
                <ng-container *ngFor="let attachment of mailDetail.attachments; let i = index">
                    <a *ngIf="attachment.FileName"
                       (click)="viewFile(attachment.Base64String, attachment.FileType, attachment.FileName)">
                        <!-- TODO: view -->
                        {{attachment.FileName}}
                    </a>
                </ng-container>
            </div>
        </div>

        <!-- Email Body -->
        <!-- This is made to be identical to the options provided by the preferences -->
        <quill-editor [(ngModel)]="mailDetail.message"
                      style="flex-grow: 1; display: flex; flex-direction: column;"
                      [style]="{'width': '100%', 'flex-grow': '1', 'display': 'flex', 'flex-direction': 'column'}">
            <!-- <div quill-editor-toolbar>
                <span class="ql-formats">
                    <select class="ql-font" [title]="'Font'"></select>
                    <select class="ql-size" [title]="'Size'"></select>
                </span>
                <span class="ql-formats">
                    <button class="ql-bold" [title]="'Bold'"></button>
                    <button class="ql-italic" [title]="'Italic'"></button>
                    <button class="ql-underline" [title]="'Underline'"></button>
                </span>
                <span class="ql-formats">
                    <select class="ql-color" [title]="'Text Color'"></select>
                    <select class="ql-background" [title]="'Background Color'"></select>
                </span>
                <span class="ql-formats">
                    <button class="ql-list" value="ordered" [title]="'Ordered List'"></button>
                    <button class="ql-list" value="bullet" [title]="'Bullet List'"></button>
                    <button class="ql-indent" value="-1" [title]="'Outdent'"></button>
                    <button class="ql-indent" value="+1" [title]="'Indent'"></button>
                </span>
                <span class="ql-formats">
                    <select class="ql-align" [title]="'Alignment'">
                        <option selected></option>
                        <option value="center"></option>
                        <option value="right"></option>
                        <option value="justify"></option>
                    </select>
                </span>
                <span class="ql-formats">
                    <button class="ql-clean" [title]="'Remove Formatting'"></button>
                </span>
            </div> -->
        </quill-editor>
    </div>
</tyl-kendo-pdf-export>
<!-- Footer -->
<div class="flex-footer">

    <!-- Left Buttons -->
    <div class="flex-footer-left">
        <tyl-button *ngIf="!optionNotAvailable && !modal"
                    image="change recipients.png"
                    label="Change Recipients"
                    (clickEvent)="changeRecipients()"></tyl-button>
    </div>

    <!-- Right Buttons -->
    <div class="flex-footer-right">
        <tyl-checkbox [(checked)]="createCommLogEntry"
                      *ngIf="staffUser && !modal"
                      style="align-self: center;">
            <span translate>Create a Communication Log Entry for this email</span>
        </tyl-checkbox>
        <error-prompt [errorList]="errors"></error-prompt>
        <ng-container *ngIf="!optionNotAvailable && !modal">
            <tyl-button image="save.png" label="Send" (clickEvent)="send()"></tyl-button>
        </ng-container>
        <div *ngIf="modal">
            <tyl-button style="float:right;" label="Cancel" image="Cancel.png" (clickEvent)="closeClick()"></tyl-button>
            <tyl-button style="float:right;" label="Send" image="save.png" (clickEvent)="send()"></tyl-button>
        </div>
    </div>
</div>
